import React from 'react';
import {AnimatePresence, motion} from "framer-motion";
import {useTranslation} from "react-i18next";

// Modale affichée sur l'écran résultat quand le match part aux tirs au but.
// Propose, en opt-in, de jouer la séance pour tenter un lot de plus. Non bloquante :
// "Plus tard" laisse l'écran résultat (un encart permet d'entrer ensuite).
export const PenaltyUpsellModal = ({isOpen, onAccept, onDecline, rewardLabel}) => {
    const {t} = useTranslation();

    return (
        <AnimatePresence>
            {isOpen && (
                <motion.div
                    className="fixed inset-0 z-[80] flex items-end sm:items-center justify-center p-4"
                    initial={{opacity: 0}} animate={{opacity: 1}} exit={{opacity: 0}}
                >
                    <div className="absolute inset-0 bg-slate-900/75 backdrop-blur-sm"/>

                    <motion.div
                        initial={{y: 60, opacity: 0, scale: 0.96}}
                        animate={{y: 0, opacity: 1, scale: 1}}
                        exit={{y: 40, opacity: 0}}
                        transition={{type: 'spring', damping: 22, stiffness: 260}}
                        className="relative z-10 w-full max-w-sm bg-brand-dark rounded-3xl p-7 overflow-hidden shadow-2xl text-center"
                    >
                        <div className="absolute -top-16 left-1/2 -translate-x-1/2 w-64 h-64 rounded-full bg-emerald-500/25 blur-[70px] pointer-events-none"/>

                        <div className="relative z-10">
                            <div className="inline-flex items-center gap-1.5 px-3 py-1 mb-4 rounded-full bg-emerald-500/15 border border-emerald-400/30">
                                <span className="text-sm leading-none">⚽</span>
                                <span className="text-[10px] font-black text-emerald-300 uppercase tracking-widest">
                                    {t('penalty.upsell_badge', 'Bonus tirs au but')}
                                </span>
                            </div>

                            <h3 className="text-2xl font-black text-white uppercase tracking-tight leading-none mb-2">
                                {t('penalty.upsell_title', 'Ça part aux tirs au but !')}
                            </h3>
                            <p className="text-sm text-gray-400 font-medium leading-relaxed mb-6">
                                {rewardLabel ? (
                                    <>
                                        {t('penalty.upsell_subtitle_reward', 'Pronostique chaque tir et tente de gagner :')}{' '}
                                        <span className="text-emerald-300 font-bold">{rewardLabel}</span>
                                    </>
                                ) : t('penalty.upsell_subtitle', 'Pronostique chaque tir et tente de gagner un lot de plus.')}
                            </p>

                            <button
                                onClick={onAccept}
                                className="w-full py-4 mb-3 bg-action-green text-white font-bold rounded-xl text-base shadow-lg hover:brightness-110 active:scale-98 transition-transform"
                            >
                                {t('penalty.upsell_accept', 'Je joue les tirs au but')} ⚽
                            </button>
                            <button
                                onClick={onDecline}
                                className="w-full py-3 text-gray-400 hover:text-white font-bold text-sm uppercase tracking-widest transition-colors"
                            >
                                {t('penalty.upsell_decline', 'Plus tard')}
                            </button>
                        </div>
                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default PenaltyUpsellModal;
